import { useMemo, useState } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { Button } from "../../ui/button";
import { ChevronDown, ChevronUp } from "../../common/icons";
import { Notebook, Users } from "lucide-react";
import ClientMatchesModal from "../modals/ClientMatchesModal";
import NotesModal from "../modals/NotesModal";

interface Props {
    applicant: string;
    applicantName: string | null;
    applicantRole?: string | null;
    isPosting: boolean;
    isMatch: boolean;
}
interface IApplicantContextMenuOption {
    icon: JSX.Element;
    title: string;
    func: () => void;
}
const ApplicantContextMenu = ({ applicant, applicantName, applicantRole, isPosting, isMatch }: Props) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [matchesModalOpen, setMatchesModalOpen] = useState<boolean>(false);
    const [notesModalOpen, setNotesModalOpen] = useState<boolean>(false);
    const menuOptions: IApplicantContextMenuOption[] = useMemo<IApplicantContextMenuOption[]>(() => {
        const options: IApplicantContextMenuOption[] = [];
        options.push({
            icon: <Notebook className="h-4 w-4" />,
            title: 'Notes',
            func: () => setNotesModalOpen(true)
        })
        if (!isMatch) {
            options.push({
                icon: <Users className="h-4 w-4" />,
                title: 'Matched Clients',
                func: () => setMatchesModalOpen(true)
            })
        }

        return options;
    }, [isMatch]);

    return (
        <>
            <DropdownMenu onOpenChange={setMenuOpen}>
                <DropdownMenuTrigger asChild>
                    <Button variant="ghost" className="min-h-[48px] px-3 rounded">
                        {applicantName}
                        {menuOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-48">
                    {menuOptions.map(({ icon, title, func }) => (
                        <DropdownMenuItem key={title} onClick={func}>
                            {icon}
                            {title}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
            <ClientMatchesModal
                open={matchesModalOpen}
                onOpenChange={setMatchesModalOpen}
                identifier={applicant}
                name={applicantName}
                role={applicantRole}
                isApplicant={true}
            />
            <NotesModal
                open={notesModalOpen}
                onOpenChange={setNotesModalOpen}
                identifier={applicant}
                userType={'applicant'}
                displayName={applicantName ?? ''}
                onCountChange={() => { }}
            />
        </>
    );
};

export default ApplicantContextMenu;
